import { config } from "../Environment";
import { GetItemResponse, UserProfile } from "../lib/types";

const tryGetUserProfile = async (retryFetch: Function) => {
    const response = await retryFetch(config.API_BASE + "/api/user/profile", {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      return undefined;
    }
    const result: GetItemResponse<UserProfile> = await response.json();
    return result.item;
  };

const stopImpersonating = async (retryFetch: Function) => {
  const response = await retryFetch(
    config.API_BASE + "/api/sysadmin/stop-impersonating",
    {
      method: "POST",
      credentials: "include",
    }
  );
  if (!response.ok) {
    throw new Error(`Failed to stop impersonating: ${response.statusText}`);
  }
  return response.json();
};

export {
    tryGetUserProfile,
    stopImpersonating
};
